/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PicturesEnum {
    FULLFRAME = 'fullframe',
    THUMBNAIL = 'thumbnail',
    LINK = 'link',
}